<template>
<body>
  <div class="sign-up-page-wrapper">
    <div class="form-block w-form">
      <form @submit.prevent="handleSubmit" id="sign-up" name="email-form" data-name="Email Form" redirect="shop" data-redirect="shop" class="signup-form modal-tight-margin">
        <a href="/#/signup2" class="close-arrow-container">
          <div class="close-arrow">
            <svg style="height: 20px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" xml:space="preserve">
              <g>
                <polygon style="fill:#010002" points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254" />
              </g>
            </svg>
          </div>
        </a>
        <h1 class="form-heading">Account Setup / Address</h1>
        <div class="modal-field-wrap">
          <label for="name" class="modal-field-label">Address</label>
          <input ref="autocomplete" v-model="address1" type="text" class="form-field modal-field-input" maxlength="100" name="email-2" data-name="name" placeholder="1212 42nd St" id="email-2" required="" />
        </div>
        <div class="modal-field-wrap">
          <label for="phone" class="modal-field-label">City</label>
          <input v-model="city" type="text" class="form-field modal-field-input" maxlength="20" name="phone" data-name="Phone" placeholder="New York City" id="phone" />
        </div>
        <div class="modal-field-wrap">
          <label for="state" class="modal-field-label">State</label>
          <input v-model="state" type="state" class="form-field modal-field-input" maxlength="3" name="state" data-name="State" placeholder="NY" id="state" required="">
        </div>
        <div class="modal-field-wrap">
          <label for="zip" class="modal-field-label">Zip Code</label>
          <input v-model="zip" type="zip" class="form-field modal-field-input" maxlength="6" name="zip" data-name="Zip" placeholder="10001" id="zip" required="">
        </div>
        <div class="submit-div">
          <div class="w-container no-margin">
            <input type="submit" value="Continue" data-wait="Please wait..." class="continue-button w-button modal-submit">
          </div>
          <div class="text-block-26 modal-steps">2/3</div>
        </div>
      </form>
      <div class="w-form-done">
        <div>Thank you! Your submission has been received!</div>
      </div>
      <div class="w-form-fail">
        <div>Oops! Something went wrong while submitting the form.</div>
      </div>
    </div>
  </div>
</body>
</template>
<script>

  import '@/assets/wss/normalize.css'
  import '@/assets/wss/components.css'
  import '@/assets/wss/supreme-access-v1.css'
const ADDRESS_COMPONENTS = {
  subpremise: 'short_name',
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  administrative_area_level_2: 'long_name',
  country: 'long_name',
  postal_code: 'short_name'
};
const CITIES_TYPE = ['locality', 'administrative_area_level_3'];
const REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country',
  'administrative_area_level_1', 'administrative_area_level_2'
];
export default {
  name: 'SignUp',
  data() {
    return {
      address1: null,
      city: null,
      zip: null,
      state: null,
    }
  },
  created() {
    this.$store.dispatch('auth/fetchUser')
  },
  mounted() {
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete), { types: ['geocode'], }
    );
    this.autocomplete.addListener('place_changed', (x) => {
      let place = this.autocomplete.getPlace();
      console.log(place)
      let ac = place.address_components;
      let lat = place.geometry.location.lat();
      let lon = place.geometry.location.lng();
      let formatted = this.formatResult(place)
      console.log(`address:`, formatted)
      // console.log(ac[0], 67, ac, place)
      // let city = ac[0]["short_name"];
      this.city  = formatted.locality
      this.address1 = formatted.street_number + ' ' + formatted.route
      this.state = formatted.administrative_area_level_1
      this.zip = formatted.postal_code
      console.log(`The user picked coordinates ${lat}, ${lon}`);
    });
  },
  methods: {
    formatResult(place) {
      let returnData = {};
      for (let i = 0; i < place.address_components.length; i++) {
        let addressType = place.address_components[i].types[0];
        if (ADDRESS_COMPONENTS[addressType]) {
          let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
          returnData[addressType] = val;
        }
      }
      returnData['latitude'] = place.geometry.location.lat();
      returnData['longitude'] = place.geometry.location.lng();
      return returnData
    },
    handleSubmit(e) {
      console.log('form submitted')
      let { address1, city, zip, state } = this
      if (address1 && city && zip && state) {
        let billingAddress = { address1, city, zip, state }
        let payload = { billingAddress }
        console.log(`dispatching address to setup with payload`, payload)
        this.$store.dispatch('setup/step2', payload)
      }
    }
  },
  watch: {
    '$route'(to, from) {
      // react to route changes...
      this.token = this.$route.query.token
    }
  }

}
</script>
<style>
.sign-up-page-wrapper {
  padding: 5px;
}
</style>
